import { isStaging, isDev } from "./environment";

const APP_NAME = "BLAZE Brands";

export function formatPageTitle(pageLabel: string) {
  let environmentLabel = "";
  if (isDev()) {
    environmentLabel = "[development] ";
  } else if (isStaging()) {
    environmentLabel = "[staging] ";
  }

  return `${pageLabel} | ${environmentLabel}${APP_NAME}`;
}
